import { render, staticRenderFns } from "./rlzy_guanlian_qiye.vue?vue&type=template&id=066adf38&scoped=true"
import script from "./rlzy_guanlian_qiye.vue?vue&type=script&lang=js"
export * from "./rlzy_guanlian_qiye.vue?vue&type=script&lang=js"
import style0 from "./rlzy_guanlian_qiye.vue?vue&type=style&index=0&id=066adf38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066adf38",
  null
  
)

export default component.exports